<script lang="ts">
    import { RuleEngine } from "../RuleEngine"
    import inputfields from "./"

    export let ftpAssetsUrl: string

    // Choices from MailboxFilter
    export let currentChoices = null

    export let value: {
        [key: string]: any
    } = {}
    export let dependsOn: OfferAssistantDependsOnRule[]
    export let label: string
    export let subFields: OfferAssistantSubField[] = []
    export let values: { [key: string]: any }
    values = values || null

    const ruleEngine = new RuleEngine()
    let displayComponent: boolean = true

    $: if (values && dependsOn) {
        displayComponent = ruleEngine.resolve(dependsOn, values)
    }
</script>

{#if displayComponent}
    <div class="object">
        {#if label}
            <label for="">{label}</label>
        {/if}
        {#each subFields || [] as field}
            <svelte:component
                this="{inputfields[field.widget || field.type] || inputfields.default}"
                {...field}
                {values}
                bind:value="{value[field.name]}"
                {currentChoices}
                on:invalid-config
                {ftpAssetsUrl}
            />
        {/each}
    </div>
{/if}
